import classNames from 'classnames';
import React, { useContext } from 'react';
import { Subtitle2, Body1, makeStyles } from '@fluentui/react-components';
import { ScopeContext } from '@bingads-webui-react/scope-service';

import { useTipsConfig } from './use-tips-config';

const useTipStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  imageContainer: {
    flexGrow: 1,
    flexBasis: 0,
    maxHeight: '210px',
    width: '100%',
    overflowY: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundImage: 'linear-gradient(to right, #E4E2F3, #E3EDF3)',
  },
  image: {
    maxHeight: '148px',
  },
  title: {
    marginTop: '16px',
  },
});

export const Tip = ({
  tipId, showWelcomeMsg, isPaymentFirstTile, hasCoupon, name, i18n,
}: { tipId: string, showWelcomeMsg: boolean, isPaymentFirstTile: boolean, hasCoupon: boolean, name: string, i18n: any }) => {
  const styles = useTipStyles();
  const { scope } = useContext(ScopeContext) as any;

  const config = useTipsConfig({
    showWelcomeMsg, isPaymentFirstTile, hasCoupon, name, i18n, styles, scope,
  });

  return (
    <div className={classNames('tip-container', styles.container)}>
      <div className={classNames(styles.imageContainer)}>
        {config[tipId].image}
      </div>
      <Subtitle2 className={classNames('title', styles.title)}>{config[tipId].title}</Subtitle2>
      <Body1 className="text">{config[tipId].text}</Body1>
    </div >
  );
};
